// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iv_a bhf_sq","PhotoTitleEditForm__cancelBtn":"iv_b bhf_su bhf_st"};